<div class="row flex-column mt-2">
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h3 class="card-title">General</h3>
                <h6 class="card-subtitle text-muted">Manage your email settings.</h6>
            </div>
        </div>
    </div>
</div>

<!-- EMAIL TEMPLATE TABLE SECTION -->
<div class="row mt-2">
    <div class="col-lg-12">
        <div class="card email-template-card">
            <div class="card-header d-flex align-items-center gap-2">
                <div>
                    <h5 class="mb-0">Email Templates</h5>
                </div>

                <div class="ms-auto d-flex align-items-center gap-2">
                    <select
                        class="form-select template-type-filter"
                        [(ngModel)]="selectedTemplateType"
                        (change)="getEmailTemplates()"
                    >
                        <option value="ALL">All Types</option>
                        <option *ngFor="let type of templateTypes" [value]="type.value">
                            {{ type.label }}
                        </option>
                    </select>

                    <button type="button" class="btn btn-primary" (click)="openCreateTemplateModal()">
                        <fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon>
                        <span>New</span>
                    </button>
                </div>
            </div>

            <div class="card-body template-table-card-body">
                <div class="table-responsive">
                    <table class="table table-hover align-middle email-template-table mb-0">
                        <thead>
                            <tr>
                                <th>Template</th>
                                @if(selectedTemplateType === 'ALL') {
                                    <th>Type</th>   
                                }
                                <th>Subject</th>
                                <th>Description</th>
                                <th>Default</th>
                                <th class="text-center actions-th">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let template of templates">
                                <td>
                                    <div class="template-name">
                                        {{ template.name }}
                                    </div>
                                    <small class="text-muted">
                                        Updated {{ formatUnixDate(template.updatedAt || template.createdAt) }}
                                    </small>
                                </td>
                                @if(selectedTemplateType === 'ALL') {
                                    <td>
                                        <span class="template-type">
                                            {{ getTemplateTypeLabel(template.type) }}
                                        </span>
                                    </td>
                                }
                                <td>
                                    <div class="template-subject">
                                        {{ template.subject }}
                                    </div>
                                </td>

                                <td>
                                    <div class="template-description">
                                        {{ getBodyPreview(template.body) }}
                                    </div>
                                </td>

                                <td>
                                    <span *ngIf="template.isDefault" class="badge bg-primary">
                                        {{template.isDefault ?  getTemplateTypeLabel(template.type) : '-'}}
                                    </span>
                                </td>

                                <td class="text-center">
                                    <div class="template-actions">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            [disabled]="template.isDefault"
                                            ngbTooltip="Set as default"
                                            (click)="setAsDefaultTemplate(template)"
                                        >
                                            <fa-icon [icon]="faStar"></fa-icon>
                                        </button>

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            ngbTooltip="Edit"
                                            (click)="openEditTemplateModal(template)"
                                        >
                                            <fa-icon [icon]="faPen"></fa-icon>
                                        </button>

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            ngbTooltip="Duplicate"
                                            (click)="duplicateTemplate(template)"
                                        >
                                            <fa-icon [icon]="faClone"></fa-icon>
                                        </button>

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            [disabled]="template.isDefault"
                                            ngbTooltip="Delete"
                                            (click)="deleteTemplate(template)"
                                        >
                                            <fa-icon [icon]="faTrash"></fa-icon>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr *ngIf="templates.length === 0">
                                <td colspan="6">
                                    <div class="template-empty-state">
                                        <div class="fw-semibold">No templates found</div>
                                        <div class="text-muted">
                                            Create your first email template for this type.
                                        </div>

                                        <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm mt-3"
                                            (click)="openCreateTemplateModal()"
                                        >
                                            <fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon>
                                            Add Template
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- TOP SECTION -->
<div class="row mt-2 align-items-stretch">
    <!-- LEFT SIDE: SENDING + RECEIVING -->
    <div class="col-lg-4 d-flex flex-column gap-2">
        <!-- SENDING -->
        <div class="card settings-equal-card">
            <div class="card-header d-flex align-items-center">
                <h5 class="mb-0">Sending</h5>

                <button type="button" class="btn btn-primary ms-auto" (click)="updateEmailSendingSettings()">
                    <fa-icon class="button-icon-left" [icon]="faSave"></fa-icon>
                    <span>Save</span>
                </button>
            </div>

            <div class="card-body">
                <form [formGroup]="emailSettingsForm">
                    <div class="mb-3">
                        <label for="EMAIL_DISPLAY_NAME">Display Name</label>
                        <input
                            id="EMAIL_DISPLAY_NAME"
                            type="text"
                            class="form-control"
                            formControlName="displayName"
                            placeholder="Appleseed Contractors"
                        />
                    </div>

                    <div>
                        <label for="EMAIL_REPLY_TO">Reply To</label>
                        <input
                            id="EMAIL_REPLY_TO"
                            type="text"
                            class="form-control"
                            formControlName="replyTo"
                            placeholder="shared@example.com"
                            autocapitalize="off"
                        />
                    </div>
                </form>
            </div>
        </div>

        <!-- RECEIVING -->
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">Receiving</h5>
            </div>

            <div class="card-body">
                <label for="PROSPECTS_EMAIL">Prospects Email</label>

                <div class="input-group">
                    <input
                        id="PROSPECTS_EMAIL"
                        type="text"
                        class="form-control"
                        [value]="prospectEmail"
                        disabled
                    />

                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="copyProspectsEmail()"
                        ngbTooltip="Copy"
                        aria-label="Copy"
                    >
                        <fa-icon [icon]="faCopy"></fa-icon>
                    </button>

                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="openRegenerateProspectsEmailConfirmationModal()"
                        ngbTooltip="Regenerate"
                        aria-label="Regenerate"
                    >
                        <fa-icon [icon]="faRotate"></fa-icon>
                    </button>

                    <a
                        href="https://support.tinselcrm.com/knowledge-base/prospect-email-receiving/"
                        target="_blank"
                        class="btn btn-outline-primary"
                        ngbTooltip="Help"
                        aria-label="Help"
                    >
                        <fa-icon [icon]="faQuestion"></fa-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- RIGHT SIDE: LOGS -->
    <div class="col-lg-4 mt-lg-0 mt-2 d-flex">
        <div class="w-100 settings-equal-card">
            <app-settings-emails-logs></app-settings-emails-logs>
        </div>
    </div>
</div>


